export interface DropdownProps {
  field: string
  placeholder?: string
  options: string[]
  required?: boolean
  onChange: (field: string, value: string, isValid: boolean) => void
  className?: string
  revalidate: boolean
}

export type DropdownState = {
  value: string
  isValid: boolean
  touched: boolean
  active: boolean
}

export enum ActionTypes {
  DROPDOWN_CHANGE = 'DROPDOWN_CHANGE',
  DROPDOWN_BLUR = 'DROPDOWN_BLUR',
  DROPDOWN_FOCUS = 'DROPDOWN_FOCUS',
}

type DropdownChangeType = {
  type: typeof ActionTypes.DROPDOWN_CHANGE
  value: string
  isValid: boolean
}

type DropdownFocusType = {
  type: typeof ActionTypes.DROPDOWN_FOCUS
}

type DropdownBlurType = {
  type: typeof ActionTypes.DROPDOWN_BLUR
}

export type DropdownActionTypes = DropdownChangeType | DropdownFocusType | DropdownBlurType
